import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const tickerVariants = cva('', {
  variants: {
    variant: {
      gold: css.gold,
      'ticker-center': css['ticker-center'],
      'gold-small': css['gold-small'],
      red: css.red,
      'red-small': css['red-small'],
      purple: css.purple,
      blue: css.blue,
      green: css.green,
    },
  },
});

interface TickerProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof tickerVariants> {
  classnamesinblock?: string;
  classnamestext?: string;
  text: string;
  extraVariant?: 'gold' | 'blue' | 'red' | 'purple' | 'green';
}

const Ticker = forwardRef<HTMLDivElement, TickerProps>(
  ({ variant, extraVariant, text, ...props }, ref) => {
    return (
      <div ref={ref} {...props} className={cn('relative', props.className)}>
        <div
          className={cn(
            tickerVariants({ variant }),
            extraVariant ? css[`${variant}--${extraVariant}`] : '',
            props.classnamesinblock,
          )}
        >
          <span
            className={cn(
              extraVariant
                ? css[`${variant}--${extraVariant}Text`]
                : css[`${variant}Text`],
              props.classnamestext,
            )}
          >
            {text}
          </span>
        </div>
        <span className={css[`${variant}Polygon`]}></span>
        {variant === 'ticker-center' && (
          <>
            <span className={css[`${variant}--${extraVariant}Polygon`]}></span>
            <span
              className={css[`${variant}--${extraVariant}Polygon--right-top`]}
            ></span>
          </>
        )}
        {variant === 'gold-small' && (
          <span className={css[`${variant}Polygon--right-bottom`]}></span>
        )}
      </div>
    );
  },
);

export { Ticker };
